import script from "./CastleItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CastleItem.vue?vue&type=script&setup=true&lang=js"

import "./CastleItem.vue?vue&type=style&index=0&id=22e6dae0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22e6dae0"]])

export default __exports__